<!-- 商品详情 -->
<template>
  <van-popup
    v-model="show"
    round
    closeable
    z-index="109"
    position="bottom"
    class="product_detail_popup"
    :style="{ height: '60%' }"
    @close="handleClose"
  >
    <div class="product_detail_wrap">
      <div class="product_title van-hairline--bottom">{{ title }}</div>
      <div
        v-if="content.length > 0"
        class="product_detail"
        v-html="content"
      ></div>

      <van-empty
        v-else
        :description="$t('ticket.empty.intro')"
      />
    </div>
  </van-popup>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '标题',
    },
  },
  name: 'ProductDetail',
  data() {
    return {}
  },

  watch: {
    content(val) {
      if (val) {
        this.resetAclick()
      }
    }
  },

  components: {},

  methods: {
    // 关闭详情
    handleClose() {
      this.$emit('listenCloseDetail')
    },
    // 重置a标签点击事件
    resetAclick() {
      this.$nextTick(() => {
        let eles = document.getElementsByTagName('a')
        eles.forEach(ele => {
          if (ele.href) {
            ele.onclick = () => {
              window.location.href = ele.href
            }
          }
        })
      })
    },
  },

  mounted() { },
}
</script>
<style lang="less" scoped>
.product_detail_popup {
  z-index: 110 !important;
}
.product_detail_wrap {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-flow: column;
  .product_title {
    font-size: 16px;
    text-align: center;
    line-height: 20px;
    // margin: 15px 0;
    padding: 15px 40px;
    letter-spacing: 1px;
    font-weight: bold;
  }
  /deep/.product_detail {
    flex: 1;
    padding: 15px;
    overflow-y: auto;
    font-size: 14px;
    p {
      line-height: 1.2;
    }
    // span {
    //   width: 100%;
    //   display: inline-block;
    // }
    img {
      width: 100%;
    }
    strong,
    b {
      font-weight: bold;
    }
    em,
    i {
      font-style: italic;
    }
    hr {
      display: block !important;
      unicode-bidi: isolate !important;
      margin-block-start: 0.5em !important;
      margin-block-end: 0.5em !important;
      margin-inline-start: auto !important;
      margin-inline-end: auto !important;
      overflow: hidden !important;
      border-style: inset !important;
      border-width: 1px !important;
    }
    h1 {
      margin: 0.67em 0 !important;
      font-size: 2em !important;
      font-weight: bold !important;
    }
    h2 {
      margin: 0.83em 0 !important;
      font-size: 1.5em !important;
      font-weight: bold !important;
    }
    h3 {
      margin: 1.17em 0 !important;
      font-size: 1.17em !important;
      font-weight: bold !important;
    }
    h4 {
      // font-size: 12px !important;
      margin: 1.33em 0 !important;
      font-weight: bold !important;
    }
    h5 {
      margin: 1.67em 0 !important;
      font-size: 0.83em !important;
      font-weight: bold !important;
    }
    .ql-align-center {
      text-align: center;
    }
    .ql-align-right {
      text-align: right;
    }
    .ql-align-justify {
      text-align: justify;
    }
  }
}
</style>
